export default __webpack_public_path__ + "static/media/Nesha_Laser_0002_Particle_3.2849eaa3.png";